module.exports = __webpack_public_path__ + "img/Frame5.a90fa516.png";